<template>
  <div class="page-content">
    <el-row class="search-title common-table-top" style="margin-bottom: 20px">
      <el-col :span="24" class="text-align-right">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="" style="height: 50px;text-align: left">
          <el-form-item label="选择公众号:" class="offline-activity-set-wechat-public" style="margin-left:32px">
            <el-select @change="chooseWechatPublic" v-model="ruleForm.bindPublic" placeholder="请选择公众号">
              <el-option
                v-for="item in publics"
                :key="item.id"
                :label="item.nick_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
         <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">活动配置</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-content-div form-submit-page">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  class="box-content-form">
          <el-form-item label="页面名称：" prop="pageName">
            <el-input v-model="ruleForm.pageName" placeholder="请输入页面名称"></el-input>
          </el-form-item>
          <!--图片设置-->
          <el-form-item label="封面图片：" prop="coverImg">
            <el-upload
              class="acivity-uploader add_offline_activity"
              name="file_upload"
              :action="uploadURL"
              title="可以点击图片进行换图"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="ruleForm.coverImg !== ''" :src="ruleForm.coverImg" class="useNowPhoneImg">
              <img v-if="ruleForm.coverImg === '' && is_load === true" :src="cdnImg" class="default-acivity" style="margin: 0">
            </el-upload>
          </el-form-item>
          <el-form-item label="活动描述：" prop="activityDesc">
            <el-input type="textarea" placeholder="请输入活动描述" v-model="ruleForm.activityDesc"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button @click="submitThisForm" class="second-page-btn" type="primary" style="float: left;">保 存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
import { API_HOST, CDN_IMG_HOST } from '@/api/local'
import { editPay, DetailPay, getWechatList, getWechatPublicListForNode, offlineActivitySet, getOfflineActivitySet } from '@/api/customer.js'
export default {
  name: 'offlineActivitySet',
  data () {
    return {
      id: this.$route.query.id,
      is_load: false,
      ruleForm: {
        bindPublic: '',
        pageName: '',
        activityDesc: '',
        keywords: '',
        coverImg: ''
      },
      publics: [],
      rules: {
        bindPublic: [
          { required: true, message: '请选择公众号', trigger: 'blur' }
        ],
        keywords: [
          { required: true, message: '请输入关键词', trigger: 'blur' }
        ],
        coverImg: [
          { required: true, message: '请上传封面图片', trigger: 'blur' }
        ],
        pageName: [
          { required: true, message: '请输入页面名称', trigger: 'blur' }
        ],
        activityDesc: [
          { required: true, message: '请填写活动描述', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    },
    cdnImg() {
      return CDN_IMG_HOST + 'static/image/offline-activity.png'
    }
  },
  mounted () {
  },
  methods: {
    // 提交表单
    submitThisForm() {
      if (this.ruleForm.coverImg === '') {
        this.ruleForm.coverImg = this.cdnImg
      }
      this.$refs.ruleForm.validate((pass) => {
        if (pass) {
          offlineActivitySet(this.ruleForm.keywords, this.ruleForm.pageName, this.ruleForm.coverImg, this.ruleForm.activityDesc, this.ruleForm.bindPublic).then((res) => {
            if (res.data.code === 0) {
              _g.toastMsg('success', '配置成功')
            } else {
              _g.toastMsg('error', res.data.error)
            }
          })
        }
      })
    },
    // 切换图片
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.ruleForm.coverImg = res.data.path
    },
    beforeAvatarUpload(file) {
      _g.toastMsg('success', '正在上传')
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG) {
        _g.toastMsg('上传图片只能是 JPG/PNG 格式!')
      }
      return (isJPG) || (isPNG)
    },
    // 切换公众号
    chooseWechatPublic() {
      getOfflineActivitySet(this.ruleForm.bindPublic).then((res) => {
        if (res.data.code === 0) {
          if (res.data.data !== null) {
            this.ruleForm.keywords = res.data.data.title
            this.ruleForm.pageName = res.data.data.page_name
            this.ruleForm.coverImg = res.data.data.cover_img
            this.ruleForm.activityDesc = res.data.data.content
          } else {
            this.ruleForm.keywords = ''
            this.ruleForm.pageName = ''
            this.ruleForm.coverImg = ''
            this.ruleForm.activityDesc = ''
          }
          this.is_load = true
        }
      })
    },
    // 获取设置详情
    load() {
      // 获取公众号列表
      let getWechatList = getWechatPublicListForNode()
      Promise.all([getWechatList]).then(res => {
        // 处理公众号列表
        if (res[0].data.code === 0) {
          this.publics = res[0].data.data.list
          for (let item of this.publics) {
            if (item.is_default === 1) {
              this.ruleForm.bindPublic = item.id
              getOfflineActivitySet(this.ruleForm.bindPublic).then((res) => {
                if (res.data.code === 0) {
                  if (res.data.data !== null) {
                    this.ruleForm.keywords = res.data.data.title
                    this.ruleForm.pageName = res.data.data.page_name
                    this.ruleForm.coverImg = res.data.data.cover_img
                    this.ruleForm.activityDesc = res.data.data.content
                  } else {
                    this.ruleForm.keywords = ''
                    this.ruleForm.pageName = ''
                    this.ruleForm.coverImg = ''
                    this.ruleForm.activityDesc = ''
                  }
                  this.is_load = true
                }
              })
            }
          }
        }
      })
    }
  },
  created() {
    this.load()
  }
}
</script>

<style scoped>
.acivity-uploader {
  background: transparent;
  width: auto;
  border: none;
}
.acivity-uploader {
  /*margin-top: 20px;*/
  background: #fff;
  width: 100%;
  margin: 0 auto;
  /*border: 1px solid #dcdfe6;*/
  border-radius: 5px;
  padding-top: 10px;
}
.acivity-uploader .el-upload:hover {
  border-color: #409EFF;
}
.default-acivity {
  width: 420px;
  display: block;
  margin: 23px auto 0;
}
.avatar-uploader-offline{
  width: 100%;
  height: auto;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  display: block;
}
.avatar-uploader-offline .el-upload{
  height: auto;
}
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.green{
  color: green;
}
.red{
  color: red;
}
.add-btn{
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 5px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-content-div {
  width: 750px !important;
  padding-left: 20%;
  box-sizing: border-box;
}
.box-content-form {
  margin-top: 10px;
  text-align: center;
}
.box-content-form .el-form-item {
  width: 300px;
}
.form-submit-page .box-content-form{
  width: auto;
}
.useNowPhoneImg {
  width: 420px;
}
</style>
